
import {createSlice} from '@reduxjs/toolkit'
import { fetchcandidatestatus } from '../../action/master/candidatestatusAction'

interface candidatestatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: candidatestatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const candidatestatusSlice = createSlice({
  name: 'candidatestatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchcandidatestatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchcandidatestatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchcandidatestatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default candidatestatusSlice.reducer
